(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-ai-agent-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    // CTA opens the existing sample-download dialog when the product has one.
    const cta = target.closest('[data-custom-ai-agent-cta]');
    if (cta) {
      const trigger = document.querySelector('custom-sample-download [data-sample-download-trigger]');
      if (trigger instanceof HTMLElement) {
        event.preventDefault();
        trigger.click();
      }
      return;
    }

    const copy = target.closest('[data-custom-ai-agent-copy]');
    if (!(copy instanceof HTMLElement)) return;

    const text = copy.closest('[data-custom-ai-agent-prompt]')?.querySelector('[data-custom-ai-agent-prompt-text]');
    if (!text) return;

    const selectText = () => {
      const range = document.createRange();
      range.selectNodeContents(text);
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);
    };

    const done = () => {
      copy.textContent = copy.dataset.labelDone ?? '';
      window.setTimeout(() => {
        copy.textContent = copy.dataset.labelDefault ?? '';
      }, 1800);
    };

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text.textContent ?? '').then(done, selectText);
    } else {
      selectText();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
